// Accordion smooth animation
class AccordionAnimation {
  constructor() {
    this.accordions = document.querySelectorAll('.accordion details');
    this.init();
  }

  init() {
    this.accordions.forEach(details => {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.accordion__content');
      
      if (!summary || !content) return;

      // 阻止默认的 details 行为
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggle(details, content);
      });

      // 初始化状态
      if (details.hasAttribute('open')) {
        content.style.height = content.scrollHeight + 'px';
      } else {
        content.style.height = '0px';
      }
    });
  }

  toggle(details, content) {
    const isOpen = details.hasAttribute('open');

    if (isOpen) {
      // 关闭动画
      const startHeight = content.scrollHeight;
      content.style.height = startHeight + 'px';
      
      requestAnimationFrame(() => {
        content.style.height = '0px';
      });

      // 动画结束后移除 open 属性
      setTimeout(() => {
        details.removeAttribute('open');
      }, 350);
    } else {
      // 打开动画
      details.setAttribute('open', '');
      const endHeight = content.scrollHeight;
      content.style.height = '0px';
      
      requestAnimationFrame(() => {
        content.style.height = endHeight + 'px';
      });

      // 动画结束后设置为 auto，以便内容可以自适应
      setTimeout(() => {
        content.style.height = 'auto';
      }, 350);
    }
  }
}

// 初始化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new AccordionAnimation();
  });
} else {
  new AccordionAnimation();
}

// 支持动态添加的 accordion（如快速查看）
document.addEventListener('shopify:section:load', () => {
  new AccordionAnimation();
});
